<div>
  <ng-container *ngFor="let link$ of links; index as i">
    <ng-container *ngIf="link$ | async as link">
      <span *ngIf="link.url" [class.me-4]="i!=links.length - 1">
        <ng-container *ngIf="link.linkName !== 'Cookie Preferences'; else cookiePreferences">
          <cx-generic-link [target]="link.target" [url]="link.url"
                           class="highlightable-footer-link focusable focusable__element body--xs">
            <span>{{ link.linkName }}</span>
          </cx-generic-link>
        </ng-container>
        <ng-template #cookiePreferences>
          <a (click)="truste?.eu?.clickListener(1)"
             (keydown.enter)="truste?.eu?.clickListener(1)"
             [tabIndex]="0"
             class="highlightable-footer-link focusable focusable__element ds-cursor--pointer body--xs"
          >
            <span>{{ link.linkName }}</span>
          </a>
        </ng-template>
      </span>
    </ng-container>
  </ng-container>
</div>
